"use client";

import { useEffect, useRef, useState } from "react";
import ModalVideo from "vadimages-react-modal-video";

const SeeSingularLaunchTrailer = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const linkRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = () => {
      setIsModalOpen(true);
    };

    const link = linkRef.current;
    if (link) {
      link.addEventListener("click", handleClick);
    }

    return () => {
      if (link) {
        link.removeEventListener("click", handleClick);
      }
    };
  }, []);

  return (
    <>
      <div ref={linkRef} className="absolute bottom-0 md:bottom-10 w-full">
        <div className="flex w-fit mx-auto items-center gap-1.5 text-orange duration-200 transition-all hover:underline">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="15" cy="15" r="15" fill="#F0C70D" />
            <path
              d="M12.7634 20.7634L12.7634 15.636L12.7634 10.5088L20.364 15.636L12.7634 20.7634Z"
              fill="#414042"
            />
          </svg>

          <span>See the Singular launch trailer</span>
        </div>
      </div>

      <div className="hidden md:block">
        <ModalVideo
          channel="vimeo"
          videoId="1115236169"
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
          }}
          ratio="21:9"
        />
      </div>
      <div className="block md:hidden">
        <ModalVideo
          channel="vimeo"
          videoId="1115236169"
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
          }}
          ratio="9:16"
        />
      </div>
    </>
  );
};

export default SeeSingularLaunchTrailer;
